import { useEffect, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import axios from "../config/axiosConfig";
import logo from '../images/CompanyDefaultIcon.png';

const CompanyLogo = ({
    symbol,
    alt = "Company Logo",
    className = "",
    sizes = { xs: 40, sm: 60 },
    sx // add sx prop
}) => {
    const [logoSrc, setLogoSrc] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let currentLogoSrc = null;

        const fetchLogo = async () => {
            if (!symbol) return;
            
            setLoading(true);
            
            try {
                const response = await axios.get(`/api/logo/${symbol}`, { responseType: "blob" });
                const imageUrl = URL.createObjectURL(response.data);
                currentLogoSrc = imageUrl;
                setLogoSrc(imageUrl);
            } catch (error) {
                console.error("Error fetching logo:", error);
                setLogoSrc(logo); // Use rodeo logo as fallback
            } finally {
                setLoading(false);
            }
        };

        fetchLogo();

        // Cleanup function
        return () => {
            if (currentLogoSrc && currentLogoSrc !== logo) {
                URL.revokeObjectURL(currentLogoSrc);
            }
        };
    }, [symbol]);

    // If no symbol provided, show rodeo logo
    if (!symbol) {
        return (
            <Box
                component="img"
                src={logo}
                alt={alt}
                className={className}
                sx={{
                    width: { xs: sizes.xs, sm: sizes.sm },
                    height: "auto",
                    margin: { xs: "0 auto", sm: 0 },
                    ...sx,
                }}
            />
        );
    }

    // Show loading skeleton
    if (loading) {
        return (
            <Skeleton
                variant="rectangular"
                sx={{
                    width: { xs: sizes.xs, sm: sizes.sm },
                    height: { xs: sizes.xs, sm: sizes.sm },
                    margin: { xs: "0 auto", sm: 0 },
                    ...sx,
                }}
                className={className}
            />
        );
    }

    // Show image (either fetched logo or fallback rodeo logo)
    return (
        <Box
            component="img"
            src={logoSrc || logo}
            alt={alt}
            className={className}
            sx={{
                width: { xs: sizes.xs, sm: sizes.sm },
                height: "auto",
                margin: { xs: "0 auto", sm: 0 },
                ...sx,
            }}
        />
    );
};

export default CompanyLogo;